/*************************
 * Author : Matthieu ROBIN
 *************************/
import axios, { AxiosError } from "axios";
import { ErrorResponse } from "./models/response";

const axiosInstance = axios.create({
  baseURL: window.config.API_BASE_URL,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error): Promise<ErrorResponse> => {
    if (error instanceof AxiosError) {
      const errors = error.response?.data?.errors;
      if (errors) {
        return Promise.reject({ errors });
      }
    }
    return Promise.reject({ errors: [{ msg: error.message }] });
  }
);

export default axiosInstance;
